import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import * as actions from './orderHistoryActions';
import { getCombo, getComboItemProduct } from '../Combo/comboActions';
import { editPreviousProductConfiguration } from '../ProductCustomizer/productCustomizerActions';
import OrderHistory from './OrderHistory';
import {
  getSpecificProduct,
  getSpecificProducts,
} from '../ProductCustomizer/productCustomizerActions';
import _ from 'lodash';
import { updateShortageMessageInOrderAgainProducts } from '../ProductCustomizer/productCustomizerActions';
import {
  handleCompareProducts,
  getAvailablePastOrderedProducts,
} from './utils/handleCompareProducts';
import { updateCartScreen } from '../Cart/cartActions';
import Snackbar from '@material-ui/core/Snackbar';
import Slide from '@material-ui/core/Slide';
function TransitionDown(props) {
  return <Slide {...props} direction='down' />;
}
const OrderHistoryContainer = ({
  orderHistory,
  setOrderHistoryModalIsVisible,
  addProductsToCart,
  isCategory,
  editPreviousProductConfiguration,
  updateShortageMessageInOrderAgainProducts,
  isFromPreviousOrder,
  orderHistoryModalIsVisible,
  setSingleOrderHistory,
  selectedProduct,
  products,
  combos,
  getSpecificProduct,
  selectedProducts,
  selectedLocation,
  addPastComboToCart,
  reorderAll,
  locations,
  getAvailablePastOrderedProducts,
}) => {
  const [toastMessage, setToastMessage] = useState('');
  const [transition, setTransition] = React.useState(undefined);
  useEffect(() => {
    if (toastMessage) {
      setTransition(() => TransitionDown);
    }
  }, [toastMessage]);
  // Open History Modal
  const [selectedOrderHistory, setSelectedOrderHistory] = useState({
    pastOrderedProducts: null,
    pastOrderdCombos: null,
  });
  const handleOpenHistoryModal = (
    pastOrderedProducts,
    pastOrderdCombos,
    order
  ) => {
    const selectedLocation = locations.find(
      (location) => location.id === order.business_id
    );
    setOrderHistoryModalIsVisible(true);
    const orderHistory = {
      pastOrderedProducts,
      pastOrderdCombos,
      orderDate: order.order_date,
      orderCreatedAt: order.order_created_at,
      orderLocationName: selectedLocation?.name ?? '',
    };
    setSelectedOrderHistory(orderHistory);
  };
  // Handle adding Products
  const [pastOrderedProduct, setPastOrderedProduct] = useState({});
  const [pastOrderedProducts, setPastOrderedProducts] = useState([]);
  useEffect(() => {
    if (pastOrderedProduct?.product_id) {
      getSpecificProduct(pastOrderedProduct);
    }
  }, [pastOrderedProduct?.product_id]);
  const compareOrderedProducts = useCallback(() => {
    if (
      pastOrderedProduct &&
      Object.keys(pastOrderedProduct).length &&
      selectedProduct &&
      Object.keys(selectedProduct).length &&
      selectedProduct?.product_id === pastOrderedProduct?.product_id
    ) {
      handleCompareProducts(
        pastOrderedProduct,
        selectedProduct,
        updateShortageMessageInOrderAgainProducts,
        editPreviousProductConfiguration,
        addProductsToCart,
        setPastOrderedProduct,
        setToastMessage
      );
    }
  }, [selectedProduct, pastOrderedProduct]);
  useEffect(() => {
    compareOrderedProducts();
  }, [compareOrderedProducts]);

  // Handle adding Combos
  const [pastOrderedCombo, setPastOrderedCombo] = useState();
  const [pastOrderedCombos, setPastOrderedCombos] = useState([]);
  // Handle add and reorderAll click
  const addPastOrderToCart = (pastProducts, pastCombos, isAddingSingleItem) => {
    if (isAddingSingleItem) {
      if (pastProducts) {
        setPastOrderedProduct(pastProducts);
      }
      if (pastCombos) {
        addPastComboToCart(pastCombos);
      }
    } else {
      reorderAll(pastProducts, pastCombos, setToastMessage);
    }
  };
  if (orderHistory && orderHistory.length) {
    orderHistory = orderHistory.filter((order) => order.config_products.length);
  }
  if (orderHistory && orderHistory.length && products.length) {
    return (
      <>
        <OrderHistory
          orderHistoryModalIsVisible={orderHistoryModalIsVisible}
          setOrderHistoryModalIsVisible={setOrderHistoryModalIsVisible}
          setSingleOrderHistory={setSingleOrderHistory}
          orderHistory={orderHistory.slice(0, 10)}
          products={products}
          addPastOrderToCart={addPastOrderToCart}
          isCategory={isCategory}
          editPreviousProductConfiguration={editPreviousProductConfiguration}
          isFromPreviousOrder={isFromPreviousOrder}
          selectedOrderHistory={selectedOrderHistory}
          handleOpenHistoryModal={handleOpenHistoryModal}
          selectedProducts={selectedProducts}
          selectedLocation={selectedLocation}
          combos={combos}
          locations={locations}
        />
        <div style={{ marginTop: 35 }}>
          <Snackbar
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
            open={toastMessage ? true : false}
            autoHideDuration={6000}
            onClose={() => setToastMessage('')}
            message={toastMessage}
            TransitionComponent={transition}
            key={transition ? transition.name : ''}
            style={{ marginTop: '100px', textAlign: 'center' }}
          />
        </div>
      </>
    );
  } else return null;
};

const mapStateToProps = (state) => ({
  orderHistory: mapOrderHistory(
    state.orderHistoryReducer.orderHistory,
    state.menuReducer.products
  ),
  products: state.menuReducer.products,
  combos: state.comboReducer.combos,
  selectedProduct: state.productCustomizerReducer.selectedProduct,
  selectedProducts: state.productCustomizerReducer.selectedProducts,
  isFromPreviousOrder: state.productCustomizerReducer.isFromPreviousOrder,
  selectedCombo: state.comboReducer.selectedCombo,
  combo: state.comboReducer.combo,
  selectedLocation: state.orderSettingReducer.selectedLocation,
  locations: state.locationsReducer.locations,
  orderHistoryModalIsVisible:
    state.orderHistoryReducer.orderHistoryModalIsVisible,
});

const mapOrderHistory = (orderHistory, products) => {
  return orderHistory.map((order) => {
    return {
      ...order,
      config_products: order.config_products.map((orderProduct) => {
        let foundProduct = products.find(
          (product) => product.product_id === orderProduct.product_id
        );
        if (foundProduct) {
          let foundVariant = foundProduct.prices.find(
            (price) => price.variant_id === orderProduct.variant_id
          );
          if (foundVariant) {
            return {
              ...orderProduct,
              price: foundVariant.price,
              prices: foundProduct.prices,
            };
          } else {
          }
          return orderProduct;
        } else {
          return orderProduct;
        }
      }),
    };
  });
};

export default connect(mapStateToProps, {
  ...actions,
  editPreviousProductConfiguration,
  getSpecificProduct,
  getSpecificProducts,
  updateShortageMessageInOrderAgainProducts,
  updateCartScreen,
  getCombo,
  getComboItemProduct,
  getAvailablePastOrderedProducts,
})(OrderHistoryContainer);
